import React, { useState } from 'react';
// import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { localTime } from 'utils/unitConversion';
// components
import Table from 'components/Tables/Table';
import TableRow from 'components/Tables/TableRow';
import OnlyIconBtn from 'components/Buttons/OnlyIconBtn';
import { ExternalLinkIcon } from '@heroicons/react/solid';
import StatusBadge from 'components/Badges/StatusBadge';
//import PrimaryTooltip from 'components/Tooltips/PrimaryTooltip';
import { toDate, toReadDate } from 'utils/unitConversion';
import LongLog from 'components/Modals/LongLog';
import RadixTooltip from 'components/Tooltips/RadixTooltip';
import { StopIcon } from '@heroicons/react/solid';
import { stopTaskAction } from 'redux/actions/task';
import { useDispatch } from 'react-redux';

const LogGrid = ({ connection, log, getTasks }) => {
  const [longLogModal, setLongLogModal] = useState(false);
  const [activeTask, setActiveTask] = useState({});

  function jobLog(task) {
    setActiveTask(task);
    setLongLogModal(true);
  }

  function closeJobLogHandler() {
    setActiveTask({});
    setLongLogModal(false);
  }

  const dispatch = useDispatch();


  const stopTask = async (connection, data) => {
    await dispatch(stopTaskAction({ object_type: 'Connection', object_id: connection.id, task_id: data.id }));
    await getTasks();
  };


  const headers = [
    { headerName: '', classes: 'text-center w-[50px]' },
    { headerName: '', classes: 'text-center w-[25px]' },
    { headerName: 'Timestamp', classes: '' },
    { headerName: 'Event', classes: '' },
    { headerName: 'Duration', classes: '' },
    { headerName: 'Rows Extracted', classes: '' },
    { headerName: 'Message', classes: '' },

    // { headerName: 'Entity', classes: '' },
    // { headerName: 'Log', classes: '' },
    { headerName: '', classes: '' },
  ];

  const tableBody = log.map((data, index) => {
    return (
      <tr key={index}>
        <td className="text-center  justify-center w-[125px] h-full pb-1">
          <StatusBadge status={data?.run_code || 100} />
        </td>
        <TableRow content={
          (data?.run_code || 100) == 100 && (
            <OnlyIconBtn
              icon={<StopIcon className="h-4 w-4" aria-hidden="true" />}
              onClick={() => {
                stopTask(connection, data);
              }}
            />
          )
        } />
        <TableRow content={<p>{localTime(data?.executed_at || data?.created_at)}</p>} />
        <TableRow content={<p>Extraction</p>} />
        <TableRow
          content={
            <p>
              {' '}
              {toDate(data?.finished_at) - toDate(data?.executed_at || data?.created_at) < -3600
                ? ''
                : toReadDate(toDate(data?.finished_at) - toDate(data?.executed_at || data?.created_at))}
            </p>
          }
        />
        <TableRow content={<p>{data?.records_retrieved}</p>} />
        {/* <TableRow content={<p>{data.entity}</p>} /> */}
        <TableRow
          classes="!whitespace-normal w-[40%]"
          content={
            <div className="!whitespace-normal">
              <p className={`${data?.run_code === 300 ? 'italic animate-pulse' : ''} break-words `}>
                {data?.error_description === 'running' ? 'Running' : data?.error_description}
              </p>
            </div>
          }
        />
        <TableRow
          classes="w-[40px]"
          content={
            <RadixTooltip tooltipText="Detailed log">
              <OnlyIconBtn
                onClick={() => jobLog(data)}
                icon={<ExternalLinkIcon className="text-zinc-500 h-4 w-4" />}
              />
            </RadixTooltip>
          }
        />
      </tr>
    );
  });

  return (
    <div>
      {longLogModal && (
        <LongLog
          activeTask={activeTask}
          connection={connection}
          closeJobLogHandler={closeJobLogHandler}
        />
      )}
      <Table {...{ headers, tableBody }} />
    </div>
  );
};

LogGrid.propTypes = {
  log: PropTypes.array,
  connection: PropTypes.object,
  getTasks: PropTypes.func,
};

LogGrid.defaultProps = {
  log: [],
  connection: {},
};

export default LogGrid;
